import StatusPill from "../../../Components/StatusPill";

export const CountingCard = ({ title, count, icon: Icon, Color }) => {
    const colorMap = {
        red: {
            bg: "bg-red-100",
            text: "text-red-500",
            border: "hover:border-red-500"
        },
        green: {
            bg: "bg-green-100",
            text: "text-green-500",
            border: "hover:border-green-500"
        },
        yellow: {
            bg: "bg-yellow-100",
            text: "text-yellow-500",
            border: "hover:border-yellow-500"
        },
        orange: {
            bg: "bg-orange-100",
            text: "text-orange-500",
            border: "hover:border-orange-500"
        },
        gray: {
            bg: "bg-gray-100",
            text: "text-gray-500",
            border: "hover:border-gray-500"
        },
        purple: {
            bg: "bg-purple-100",
            text: "text-purple-500",
            border: "hover:border-purple-500"
        },
        blue: {
            bg: "bg-blue-100",
            text: "text-blue-500",
            border: "hover:border-blue-500"
        },
    };

    const appliedColor = colorMap[Color] || colorMap.gray;

    return (
        <div
            className={`flex items-center cursor-pointer gap-4 p-4 bg-white shadow rounded border border-transparent ${appliedColor.border} hover:shadow-lg transition-all duration-200 dark:border dark:border-slate-600 dark:bg-slate-800`}
        >
            <div className={`p-3 rounded-full ${appliedColor.bg} dark:bg-slate-700`}>
                {Icon && <Icon className={`text-2xl ${appliedColor.text}`} />}
            </div>
            <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
                <p className="text-3xl font-bold text-gray-900 dark:text-gray-100">{count}</p>
            </div>
        </div>
    );
};

const STATUS_MAP = {
    active:   { variant: "success", label: "Active",      flicker: true },
    upcoming: { variant: "info",    label: "Upcoming" },
    planned:  { variant: "danger",  label: "Ending soon" },
};

export const CampaignProgressCard = ({ campaign }) => {
    const startDate = campaign.startDate ? new Date(campaign.startDate) : null;
    const endDate   = campaign.endDate   ? new Date(campaign.endDate)   : null;

    const fmt = (d) => d ? d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }) : "—";
    const fmtTime = (d) => d ? d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" }) : "—";

    const statusKey = String(campaign.status || "").toLowerCase();
    const status = STATUS_MAP[statusKey] ?? { variant: "neutral", label: campaign.status || "—" };

    return (
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 transition hover:-translate-y-0.5 hover:shadow-lg dark:bg-slate-900 dark:border-slate-700">
            <div className="flex items-start justify-between gap-4">
                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 dark:text-slate-400">Event Details</p>
                    <h3 className="mt-1.5 text-base font-semibold text-slate-900 dark:text-slate-100">{campaign.name}</h3>
                </div>
                <StatusPill value={status.label} variant={status.variant} flicker={status.flicker} />
            </div>

            <div className="mt-4 grid grid-cols-2 gap-3">
                <div className="rounded-xl bg-slate-50 p-3 dark:bg-slate-800">
                    <p className="text-xs uppercase tracking-[0.15em] text-slate-500 dark:text-slate-400">Start Date</p>
                    <p className="mt-1.5 text-sm font-semibold text-slate-900 dark:text-slate-100">{fmt(startDate)}</p>
                    <p className="text-xs text-slate-400 mt-0.5">{fmtTime(startDate)}</p>
                </div>
                <div className="rounded-xl bg-slate-50 p-3 dark:bg-slate-800">
                    <p className="text-xs uppercase tracking-[0.15em] text-slate-500 dark:text-slate-400">End Date</p>
                    <p className="mt-1.5 text-sm font-semibold text-slate-900 dark:text-slate-100">{fmt(endDate)}</p>
                    <p className="text-xs text-slate-400 mt-0.5">{fmtTime(endDate)}</p>
                </div>
            </div>
        </div>
    );
};



